import { initializeApp } from "firebase/app"
import { getAuth } from "firebase/auth"

// Configuración usando variables de entorno
const firebaseConfig = {
  apiKey: process.env.VUE_APP_FIREBASE_API_KEY,
  authDomain: process.env.VUE_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.VUE_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.VUE_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.VUE_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.VUE_APP_FIREBASE_APP_ID,
}

// Inicializar Firebase
const app = initializeApp(firebaseConfig);

// Firebase Analytics se quitó a propósito: estaba inicializado pero NUNCA se registró un evento
// (ni un solo logEvent en toda la app), así que solo mandaba a Google los eventos automáticos de
// una app de SALUD, sin declararlo bien en la Política de Privacidad ni pedir consentimiento
// (P1 fase 7 de la auditoría). Si algún día se quiere medir de verdad, se vuelve a agregar a
// propósito y con su casilla de consentimiento. También simplifica la CSP.

// Auth
const auth = getAuth(app);

export { app, auth }
